var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('router-view',{key:_vm.$route.fullPath,attrs:{"username":_vm.username}})],1),_c('LegalAgeMessage'),_c('cookies-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }